import React from "react";
import tw from "tailwind-styled-components";
import { Text } from "@components";

function NoData({ className, data }) {
  return (
    <Container>
      <Text className={`text-[28px] text-center font-bold ${className}`}>
        {data || "Data not found"}
      </Text>
    </Container>
  );
}

const Container = tw.div`
flex 
justify-center
items-center
w-[100%]
h-[150px]
`;

export default NoData;
